import {
  FlexEnrollment,
  FlexMember,
  FlexPackage,
  FlexProduct,
} from "../../domain/entity/FlexPackage";

export class FlexProductModel extends FlexProduct {
  static fromJson = (json) =>
    new FlexProductModel(json?.productType, json?.name);
}

export class FlexEnrollmentModel extends FlexEnrollment {
  static fromJson = (json) =>
    new FlexEnrollmentModel(
      json?.externalId,
      json?.appPid,
      json?.startDate,
      json?.premium
    );
}

export class FlexMemberModel extends FlexMember {
  static fromJson = (json) =>
    new FlexMemberModel(json?.firstName, json?.lastName, json?.dob);
}

export class FlexPackageModel extends FlexPackage {
  static fromJson = (json) =>
    new FlexPackageModel(
      json?.id,
      json?.name,
      (json?.products ?? []).map((it) => FlexProductModel.fromJson(it)),
      json?.enrollment
        ? FlexEnrollmentModel.fromJson(json?.enrollment)
        : undefined,
      // Only FlexBenefits standalone responses carry `member` (see FlexMember) --
      // left undefined rather than an empty model so consumers can tell "no member
      // data" from "a member with blank fields".
      json?.member ? FlexMemberModel.fromJson(json?.member) : undefined
    );
}
